import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7613ab8b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7613ab8b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7613ab8b')) {
      api.createRecord('7613ab8b', component.options)
    } else {
      api.reload('7613ab8b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7613ab8b&scoped=true", function () {
      api.rerender('7613ab8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/staff/index.vue"
export default component.exports